// extracted by mini-css-extract-plugin
export default {"attendance-banner__container":"styles_attendance-banner__container__hCG4P"};